/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import tabId from 'services/tabId';
import { ApplicationState } from 'store';
import {
  createViewedBiddingBulletin,
  destroyViewedBulletin,
} from 'store/modules/bulletins_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container, View } from './styles';

interface VisualizeButtonProps {
  biddingId: string;
  isViewed: boolean;
  bulletinFilterId: number;
  isViewedBy?: Array<string>;
}

const VisualizeButton = (props: VisualizeButtonProps) => {
  const { biddingId, isViewed, bulletinFilterId, isViewedBy } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    setLoading(false);
  }, [isViewed]);

  const toggleVisualize = () => {
    if (loading) return;
    setLoading(true);
    if (!isViewed)
      dispatch(
        createViewedBiddingBulletin(
          biddingId,
          profile.name,
          bulletinFilterId,
          profile?.currentCompany[tabId()],
        ),
      );
    if (isViewed)
      dispatch(
        destroyViewedBulletin(
          biddingId,
          profile.name,
          bulletinFilterId,
          profile?.currentCompany[tabId()],
        ),
      );
  };
  return (
    <Container className="d-flex align-items-center">
      <View isView={!!isViewedBy?.length}>
        <button
          className="button-visualize-bidding d-flex align-items-center mr-2 databalloon"
          type="button"
          data-balloon-pos="up"
          data-balloon-lengthmedium
          data-balloon-blunt
          onClick={toggleVisualize}
          {...(isViewedBy && isViewedBy.length > 0
            ? {
                'aria-label': isViewedBy.join('\n'),
              }
            : {
                'aria-label': 'Marcar como lida',
              })}
        >
          <i className="material-icons" style={{ color: '#fff' }}>
            visibility
          </i>
        </button>

        {isViewedBy && isViewedBy.length > 0 && (
          <span className="text-white">{isViewedBy.length}</span>
        )}
      </View>
      {loading && (
        <div className="spinner-border spinner-border-sm text-success" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      )}
    </Container>
  );
};

export default VisualizeButton;
